<div class="courses-categories-slides">
    <owl-carousel-o [options]="categoriesSlides">



        <ng-template carouselSlide *ngFor="let specialty of specialties">
            <div class="single-categories-courses-box mb-30">
                <div class="icon">
                    <i class='{{specialty.photoIcon}}'></i>
                </div>
                <h3>{{specialty.name}}</h3>
                <span>{{specialty.doctors.length}} medici</span>
                <a routerLink="/specialitati-medicale/{{specialty.id}}" class="link-btn"></a>
            </div>
        </ng-template>
    </owl-carousel-o>
</div>
